import {combineReducers, Reducer} from 'redux'
import { PeopleState } from '@models/person'
import {PeopleActionTypes} from '@actions/people';




// Type-safe initialState!
export const initialState: PeopleState = {
    allIds:[],
    byId:{},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) =>{
    switch(action.type){
        case PeopleActionTypes.FETCH_SUCCESS:{
            const{ data} = action.payload;
            return {
                ...data.reduce( (obj, person) => {
                    obj[person.id] = {
                        ...person,
                        is_fetched: false,
                        ...(state[person.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case PeopleActionTypes.CREATE_SUCCESS:{
            const person = action.payload;
            return {
                ...state,
                [person.id] : person
            };
        }

        case PeopleActionTypes.UPDATE_SUCCESS:{
            const person = action.payload;
            return {
                ...state,
                [person.id] : {
                    ...state[person.id],
                    ...person
                }
            };
        }

        case PeopleActionTypes.FETCH_ITEM_SUCCESS:{
            const person = action.payload;
            return {
                ...state,
                [person.id] : {
                    ...state[person.id],
                    ...person,
                    is_fetched: true
                },
            };
        }

        case PeopleActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case PeopleActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map( item  => item.id);
        }

        case PeopleActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case PeopleActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case PeopleActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case PeopleActionTypes.DELETE_SUCCESS:
            return state - 1;

        case PeopleActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case PeopleActionTypes.FETCH_REQUEST: {
            return true;
        }

        case PeopleActionTypes.FETCH_SUCCESS:
        case PeopleActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<PeopleState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export { reducer as peopleReducer }




//Selectors
export const getPeopleList = people => people.allIds.map( id => people.byId[id]);
export const getPersonById = (people, id) => people.byId[id];